import React, { useState, useEffect, Fragment, useRef } from "react";
import "./_home.scss";
import "./scrollUp.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  FreeMode,
  Pagination,
  Autoplay,
  Navigation,
  Mousewheel,
} from "swiper/modules";
import CountUp, { useCountUp } from "react-countup";
import { Player, BigPlayButton } from "video-react";
import "video-react/dist/video-react.css";
// import heroImage from "../../Assets/Images/play-button.svg";
import * as Images from "../../Assets/Images/images";
import Cama from "../../Assets/Images/Cama.png";

import BookDemo from "../Login/BookDemo";
import 'animate.css';

const tabsFirst = [
  { label: 'Loyalty', id: 'Loyalty', top: '80px' },
  { label: 'Campaign', id: 'Campaign', top: '100px' },
  { label: 'Referral', id: 'Referral', top: '120px' },
  { label: 'Dashboard', id: 'Dashboard', top: '140px' },
  { label: 'Feedback', id: 'Feedback', top: '160px' },
  { label: 'DigitalReceipt', id: 'DigitalReceipt', top: '180px' },
];
const title = localStorage.getItem('name');
// console.log(title, "title")

export default function Home() {
  const [activeTab, setActiveTab] = useState(1);
  const [show, setShow] = useState(false);
  const [showSection, setShowSection] = useState(false);
  const [activeTabFirst, setActiveTabFirst] = useState(tabsFirst[0].label);
  const [fadeIn, setFadeIn] = useState(false);  // To manage fade-in and fade-out effect
  const [lastScrollTime, setLastScrollTime] = useState(null);
  const [headerShow, setHeaderShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeSlideName, setActiveSlideName] = useState('Loyalty');
  const [swiperInstance, setSwiperInstance] = useState(null); // Store swiper instance
  const [prevIndex, setPrevIndex] = useState(5);


  useEffect(() => {
    const verticalSlideElems = document.querySelectorAll('#swiper_boxid > div');
    document.addEventListener('scroll', () => {
      for (let index = 0; index < verticalSlideElems.length; index++) {
        if (verticalSlideElems[index].style.display === 'none') {
          verticalSlideElems[index].style.display = 'block';
        }
      }
    })
    return () => document.removeEventListener('scroll', () => { });
  }, []);

  // Function to handle tab click and scroll to the section
  const handleTabClick = (tabIndex, topvalue) => {
    const tab = tabsFirst[tabIndex];
    const section = document.getElementById(tab.id);
    if (prevIndex === '') {
      setPrevIndex(tabIndex);
      // Set the clicked tab as active
      setActiveSlide(tab.label);
      // Show the section for the current tab and scroll to it
      if (section) {
        section.style.display = 'block';  // Ensure the current section is visible
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Hide sections from tabIndex + 1 to prevIndex
      let k = 5 - tabIndex
      if (tabIndex < prevIndex) {
        for (let i = tabIndex + 1; i < 6; i++) {
          const tablock = tabsFirst[i];  // Get the next section to hide
          const hidesection = document.getElementById(tablock.id);

          if (hidesection) {
            hidesection.style.display = 'none';  // Hide the section
          }
        }
      } else {
        // Set the clicked tab as active
        for (let j = 0; j <= tabIndex; j++) {
          const tablock2 = tabsFirst[j];  // Get the next section to hide
          const showdiv = document.getElementById(tablock2.id);
          // Show the section for the current tab and scroll to it

          if (showdiv) {
            showdiv.style.display = 'block';  // Ensure the current section is visible
            showdiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          setActiveSlide(tab.label);
        }
      }
      setPrevIndex(tabIndex);
      setActiveTabFirst(tab.label);
    }
    const hidesection = document.getElementById(tab.id);
    if (tab) {
      hidesection.style.display = 'block';  // Ensure the current section is visible
      hidesection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

  };
  const handleScrollUp = (index) => {
    const tablock = tabsFirst[index];
    setActiveTabFirst(tablock.label)
    console.log(tablock.label)
    for (let j = 0; j <= 5; j++) {
      const tablock2 = tabsFirst[j];  // Get the next section to hide
      const showdiv = document.getElementById(tablock2.id);
      // Show the section for the current tab and scroll to it

      if (showdiv) {
        showdiv.style.display = 'block';  // Ensure the current section is visible
        showdiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  const handleScroll = () => {
    setShowSection(tabsFirst)
    // Check if scrollY is greater than 500px

    tabsFirst.forEach((tab) => {
      const section = document.getElementById(tab.id);

      // Check if the section exists before accessing its properties
      if (section) {
        const sectionTop = section.getBoundingClientRect().top;
        const sectionBottom = section.getBoundingClientRect().bottom;

        // If the section is in the middle of the viewport, set it as active
        if (sectionTop <= window.innerHeight / 2 && sectionBottom >= window.innerHeight / 2) {
          setActiveTabFirst(tab.label);
        }
      }
    });
  };
  // Add scroll event listener
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);





  // const handleSlideChange = (swiper) => {
  //   setActiveSlide(swiper.activeIndex);
  //   setActiveTabFirst(tabsFirst[swiper.activeIndex]?.label)
  //   setActiveSlideName(tabsFirst[swiper.activeIndex]?.label)
  // };
  // const handleTabClick = (index) => {
  //   setActiveTabFirst(index); // Update active tab when button is clicked
  //   swiperInstance?.slideTo(index); // Programmatically change slide on button click
  // };
  const handleTabActive = (tabNo) => {
    setActiveTab(tabNo);
  };


  // Hide the hea
  // const convert =(value)=>{
  //   if(value>=1000000)
  //   {
  //       value=(value/1000000).toFixed(1) + 'M'
  //   }
  //   else if(value>=1000)
  //   {
  //       value=(value/1000).toFixed(1)+"K";
  //   }
  //   return value;
  // }

  const convert = (value) => {
    if (value >= 1000000) {
      value = (value / 1000000).toFixed();
    } else if (value >= 1000) {
      value = (value / 1000).toFixed();
    }
    return value;
  };

  useCountUp({
    ref: "counter",
    end: 1234567,
    enableScrollSpy: true,
    scrollSpyDelay: 1000,
  });
  const swiperRef = useRef();


  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      if (window.scrollY > 2700) {
        setHeaderShow(true); // Show the div
      } else {
        setHeaderShow(false); // Hide the div
      }
      if (window.scrollY > 6700) {
        setHeaderShow(false); // Hide the div
      }
      const isMobile = window.innerWidth <= 768; // Check if it's mobile view

      if (isMobile) {
        setHeaderShow(false); // Always hide the header on mobile view
      }

    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setActiveTabFirst(localStorage.getItem('name'))
    localStorage.removeItem('name');
    setFadeIn(false);
    const timer = setTimeout(() => {
      setFadeIn(true);
    }, 200); // Adjust this timing as needed
    return () => clearTimeout(timer);
  }, []);

  return (

    <Fragment>
      {/* {headerShow ?
        <div
          className={`tab-titles sticky-header ${fadeIn ? 'animate__animated animate__fadeInDown ' : 'animate__animated animate__fadeOutUp '}`}
          style={{
            position: 'sticky', top: 0, zIndex: 9999, width: '100%', background: '#ffffff',
            height: '60px'
          }}
        >
          {tabsFirst.map((tab, index) => (
            <button
              key={index}
              onClick={() => handleTabClick(index)} // Handle button click to change slides
              className={activeTabFirst === tab.label ? 'active' : ''}
            >
              {tab.label}
            </button>
          ))}
        </div>
        : null} */}
      <section className="hero-section">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="hero-heading">Simplify Engagement</h1>
              <h2 className="hero-main-heading">Ignite Loyalty</h2>
              <div className="animate-contain">
                <div className="animated-text">
                  <h1 className="heading_change">Drive Growth</h1>
                  <h1 className="heading_change">Drive Growth</h1>
                  <h1 className="heading_change">Drive Growth</h1>
                  <h1 className="heading_change">Drive Growth</h1>
                </div>
              </div>
              <h3 className="hero-heading">
              Pocket CRM & Loyalty 
              </h3>
              <h3 className="hero-para hero-para-custom">Platform Built for You</h3>
              <div className="mt-4 hidden-xs hidden-md">
                <button
                  className="btn btn-schedule-demo"
                  onClick={() => handleShow()}>
                  Schedule a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              {/* <Player src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4">
                <BigPlayButton position="center" />
              </Player> */}
              <div className="hero-image-container">
                <img src={Images.poppin_landing_banner} className="main-image" alt="" />
              </div>
              <div className="mt-5 visible-xs visible-md text-center">
                <button
                  className="btn btn-schedule-demo"
                  onClick={() => handleShow()}>
                  Schedule a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="brand-logo-section">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col">
              <Swiper
                slidesPerView={2}
                spaceBetween={10}
                // pagination={{
                //   clickable: true,
                // }}
                modules={[FreeMode, Autoplay]}
                loop={true}
                breakpoints={{
                  640: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                  768: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                  },
                  1024: {
                    slidesPerView: 6,
                    spaceBetween: 50,
                  },
                }}
                className="mySwiper"
                autoplay={{ delay: 1000, disableOnInteraction: false }}
                speed={12000}>
                <SwiperSlide>
                  <div className="logo-container ">
                    <img src={Images.Budget_shop} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Cama} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img
                      src={Images.Chicco}
                      className="brand-logo"
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Cottonworld} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Estilo} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Gemini_continental} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Gemtree} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.grand_resort} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Grape_county} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img
                      src={Images.Identiti}
                      className="brand-logo"
                      alt=""
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Indera_Textiles} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>





                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Kalamandir} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Kolkata_Mart} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Kolkata_Mart} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Life_saver} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.MNB} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Mustard} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.nuts_spices} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.pegs} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.pintoo} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Purple_Turtles} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Purple} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.ranjhans} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.salt} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Shiraz_hotel} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.snk_royale} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.sohum} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.success} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.TAB_Sports} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.tarasuns} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.TSG_Logo} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.TSG} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Titan} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.Tuli_imperial} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.vintage} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logo-container">
                    <img src={Images.zink_london} className="brand-logo" alt="" />
                  </div>
                </SwiperSlide>
              </Swiper>

              {/* <ul className="logo-container list-inline d-flex">
                <li>
                  <img src={Images.brandLogo} className="main-image" alt="" />
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="row align-items-center justify-content-between column-reverse">
            <div className="col-lg-6 text-center">
              <div className="diy-image-container">
                <img src={Images.diyPlatform} className="main-image" alt="" />
                <img
                  src={Images.diyIcon1}
                  className="diy-icon-1 icon-animation"
                  alt=""
                />
                <img
                  src={Images.diyIcon2}
                  className="diy-icon-2 icon-animation"
                  alt=""
                />
                <img
                  src={Images.diyIcon3}
                  className="diy-icon-3 icon-animation"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-6 px-5">
              <h3 className="text-normal-heading mb-3">
                Easy to use DIY Platform
              </h3>
              <h4 className="text-heading mb-4">
                Affordable Loyalty. Extraordinary Results.
              </h4>
              <p className="text-para">
                Delight customers, build loyalty, & increase sales through
                <b> personalized rewards, targeted campaigns,</b> and{" "}
                <b>streamlined communication.</b>
              </p>
              <p className="text-para">
                Whether you're a small boutique or a large supermarket, Popin is
                your ultimate <b>customer engagement</b> solution.
              </p>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-lg-9 m-auto">
              <div className="d-flex justify-content-center text-center flex-column">
                <p className="text-para mb-4 text-para-custom">
                  Connect with your customers across multiple channels and grow
                  your business with a single dashboard to tackle all problems!
                </p>
                <div>
                  <button
                    className="btn btn-schedule-demo"
                    onClick={() => handleShow()}>
                    Schedule a Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="page-content thrive-section mb-5">
        <img src={Images.thriveIcon1} className="thrive-icon-1" alt="" />
        <div className="blank-box"></div>
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-5">
              <h3 className="text-normal-heading mb-3">
                Craft Customer Connections
              </h3>
              <h4 className="text-heading mb-4">
                Simplify, Engage,
                <br /> Thrive.
              </h4>

              <div className="hidden-xs hidden-md">
                <p className="text-para mt-4 mb-4">
                  Unlock the Power of Popin today
                </p>
                <button
                  className="btn btn-schedule-demo"
                  onClick={() => handleShow()}>
                  Schedule a Demo
                </button>
              </div>
            </div>
            <div className="col-lg-7 text-center">
              <div className="thrive-card-container">
                <div className="flip-card">
                  <div className="thrive-card">
                    <div className="card-content">
                      <div className="card-front-side">
                        <img src={Images.thriveIcon2} className="card-icon" alt="" />
                        <h4 className="card-heading text-start">
                          The Challenge
                        </h4>
                        <p className="text-para text-start">
                          As a <b>business owner,</b> you face unique challenges
                          while <b>building</b> and{" "}
                          <b>maintaining strong customer relationships.</b>
                        </p>
                      </div>
                      <div className="card-back-side">
                        <div>
                          <ul className="list-unstyled">
                            <li>
                              <span>
                                <img src={Images.circleCheck} alt="" />
                              </span>
                              <span>Limited resources? </span>
                            </li>
                            <li>
                              <span>
                                <img src={Images.circleCheck} alt="" />
                              </span>
                              <span>Right tools? </span>
                            </li>
                            <li>
                              <span>
                                <img src={Images.circleCheck} alt="" />
                              </span>
                              <span>Budget? </span>
                            </li>
                          </ul>
                          <p className="text-para">So much to worry about…</p>
                          <p className="text-para">
                            That's where Popin comes in!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flip-card black-card">
                  <div className="thrive-card">
                    <div className="card-content">
                      <div className="card-front-side">
                        <img src={Images.thriveIcon3} className="card-icon" alt="" />
                        <h4 className="card-heading text-start">
                          The Solution
                        </h4>
                        <p className="text-para text-start">
                          A comprehensive <b>solution designed</b> to{" "}
                          <b>simplify customer engagement</b> and{" "}
                          <b>drive business growth - Popin</b>{" "}
                        </p>

                        <p className="text-para text-start">
                          <b>Integrate. Automate. Elevate.</b>
                        </p>
                      </div>
                      <div className="card-back-side">
                        {/* <img src={Images.thriveIcon3} className="card-icon" alt="" /> */}
                        {/* <h4 className="card-heading">The solution</h4> */}
                        <ul className="list-unstyled">
                          <li>
                            <span>
                              <img src={Images.circleCheck} alt="" />
                            </span>
                            <span>Easy DIY Platform</span>
                          </li>
                          <li>
                            <span>
                              <img src={Images.circleCheck} alt="" />
                            </span>
                            <span>End-to-End Customer Engagement Tools</span>
                          </li>
                          <li>
                            <span>
                              <img src={Images.circleCheck} alt="" />
                            </span>
                            <span>Easy on the Pocket</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="visible-xs visible-md">
                <p className="text-para mt-4 mb-4">
                  Unlock the Power of Popin today
                </p>
                <button
                  className="btn btn-schedule-demo"
                  onClick={() => handleShow()}>
                  Schedule a Demo
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content performance-section">
        <img src={Images.performanceMainIamge} className="performance-cover" alt="" />
        <div className="blank-box"></div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="performance-text-container">
                <div className="banner-over-text col-10">
                  <div className="col-lg-5">
                    <h2 className="text-heading">Performance Powerhouse</h2>
                  </div>
                  <div className="col-lg-7 border-left">
                    <p className="text-para">
                      Grow Alongside Industry Leaders with Features that Fuel
                      Business Success{" "}
                    </p>
                    <p className="text-para">
                      Everything you need to{" "}
                      <b>engage customers, manage loyalty programs,</b> and{" "}
                      <b>track performance</b>
                    </p>
                  </div>
                </div>
                {/* <div className="d-flex justify-content-end col-10 mt-3 gap-3">
                  <button className="btn btn-prev" onClick={() => swiperRef.current?.slidePrev()}>
                   <img src={Images.leftAngle} alt={`left`}/>
                  </button>
                  <button className="btn btn-prev" onClick={() => swiperRef.current?.slideNext()}>
                  <img src={Images.rightAngle} alt={`right`}/>
                  </button>
                </div> */}

                <div className="performance-card-slide mt-2">
                  <Swiper
                    // slidesPerView={3}
                    // spaceBetween={50}
                    autoHeight={true}
                    pagination={{
                      clickable: true,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    onBeforeInit={(swiper) => {
                      swiperRef.current = swiper;
                    }}
                    breakpoints={{
                      640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      768: {
                        slidesPerView: 1,
                        spaceBetween: 40,
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                      },
                    }}
                    className="mySwiper">
                    <SwiperSlide>
                      <div className="performance-card">
                        <img src={Images.performanceCard1} alt="" />
                        <div className="p-card-body">
                          <h4 className="p-card-heading">
                            Budget-Friendly Brilliance
                          </h4>
                          <p className="p-card-para">
                            Affordable pricing plans that allow you to
                            implement effective customer engagement strategies without{" "}
                            exceeding your budget.
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="performance-card">
                        <img src={Images.performanceCard2} alt="" />
                        <div className="p-card-body">
                          <h4 className="p-card-heading">
                            Seamless Simplicity
                          </h4>
                          <p className="p-card-para">
                            Designed with simplicity in mind, making it easy to  navigate and{" "}
                            utilize features , regardless of{" "}
                            technical expertise.
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="performance-card">
                        <img src={Images.performanceCard3} alt="" />
                        <div className="p-card-body">
                          <h4 className="p-card-heading">Boost Sales </h4>
                          <p className="p-card-para">
                            Customized loyalty programs that incentivize customers{" "}
                            to return and make  repeat purchases, driving sales & boosting customer retention.
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="performance-card">
                        <img src={Images.performanceCard4} alt="" />
                        <div className="p-card-body">
                          <h4 className="p-card-heading">
                            Stop Juggling Platforms
                          </h4>
                          <p className="p-card-para">
                            From
                             email, SMS to social media and{" "}
                            WhatsApp, reach customers everywhere,{" "}
                            ensuring consistent &{" "}
                            personalized communication.
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="d-flex justify-content-center text-center flex-column">
                <p className="text-para mb-4 text-para-custom">
                  Unlock the power of DIY Customer Engagement
                </p>
                <div>
                  <button
                    className="btn btn-schedule-demo"
                    onClick={() => handleShow()}>
                    Get in Touch
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {headerShow ?
        <div
          className={`tab-titles sticky-header ${fadeIn ? 'animate__animated animate__fadeInDown ' : 'animate__animated animate__fadeOutUp '}`}
          style={{
            position: 'sticky', top: 0, zIndex: 9999, width: '100%', background: '#99449a',
            height: '60px'
          }}
        >
          {tabsFirst.map((tab, index) => (
            <button
              key={index}
              onClick={() => handleTabClick(index)} // Handle button click to change slides
              className={activeTabFirst === tab.label ? 'active' : ''}
            >
              {tab.label}
            </button>
          ))}
        </div>
        : <div className="placeHolderElem"></div>}

      <section className="page-content" >
        <div className="container">
          <div className="row">
            <div className="col-lg-10 m-auto text-center">
              <h3 className="text-normal-heading mb-3">
                ‘Popin' Your Way to Success
              </h3>
              <h4 className="text-heading mb-4">
                Features Made Easy & Oh-so-Satisfying for Thriving Businesses
                Like Yours
              </h4>
            </div>
          </div>

          <div className="framer-WCzw1 swipper-box" id="swiper_boxid">
            <div className="framer-1elgmq9" id="Loyalty" onWheel={() => handleScrollUp(0)}>
              <div className="row align-items-center justify-content-center gap-5 ">
                <div className="col-lg-6 text-center">
                  <div className="diy-image-container">
                    <img src={Images.wayToSucces} className="main-image" alt="" />
                    <img
                      src={Images.wayToSuccesIcon1}
                      className="diy-icon-1 mt-3 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayToSuccesIcon2}
                      className="diy-icon-4 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayToSuccesIcon3}
                      className="diy-icon-3 icon-animation"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <h4 className="text-sub-heading mb-3">Loyalty</h4>
                  <p className="text-para">
                    Build a Loyal Fan Base with a DIY Loyalty Program that
                    makes them say “WOW!”
                  </p>
                  <ul className="timeline">
                    <li>
                      <h4>Customizable Loyalty Programs</h4>
                      <p>
                        DIY programs with customizable tiers, rewards, and
                        redemption options
                      </p>
                    </li>
                    <li>
                      <h4>Rewards Options</h4>

                      <p>
                        Reward your customers with loyalty points, vouchers,
                        or coupons for every purchase they make
                      </p>
                    </li>
                    <li>
                      <h4>Personalized Incentives</h4>
                      <p>
                        Offer incentives to customers basis their shopping behaviour and preferences
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="framer-6lh31u" id="Campaign" onWheel={() => handleScrollUp(1)}>
              <div className="row align-items-center justify-content-center gap-5 ">
                <div className="col-lg-6 text-center">
                  <div className="diy-image-container">
                    <img src={Images.wayToSuccesCommunication} className="main-image" alt="" />
                    <img
                      src={Images.wayTosuccessCommIcon1}
                      className="way-to-s-icon-1  mt-3 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessCommIcon2}
                      className="way-to-s-icon-2 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessCommIcon3}
                      className="way-to-s-icon-3  icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessCommIcon4}
                      className="way-to-s-icon-4  icon-animation"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <h4 className="text-sub-heading mb-3">Campaign</h4>
                  <p className="text-para">
                    Automate. Personalize. Engage. It's that easy
                  </p>
                  <ul className="timeline">
                    <li>
                      <h4>Personalized Push </h4>
                      <p>
                        Send targeted & personalized push notifications to
                        keep customers engaged and informed across their
                        lifecycle
                      </p>
                    </li>
                    <li>
                      <h4>Segmented Campaigns</h4>
                      <p>
                        Deliver targeted promotions based on customer
                        behaviour; abandoned carts, purchase history
                      </p>
                    </li>
                    <li>
                      <h4>Bulk Broadcasts </h4>
                      <p>
                        Reach a large audience to get your message across quickly and efficiently  on all channels 
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="framer-veg9ke" id="Referral" onWheel={() => handleScrollUp(2)}>
              <div className="row align-items-center justify-content-center gap-5 ">
                <div className="col-lg-6 text-center">
                  <div className="diy-image-container">
                    <img src={Images.wayTosuccessReferral} className="main-image" alt="" />
                    <img
                      src={Images.wayTosuccessReferralIIcon1}
                      className="way-to-s-ReferralIcon-1 mt-3 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessReferralIIcon2}
                      className="way-to-s-ReferralIcon-2 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessReferralIIcon3}
                      className="way-to-s-ReferralIcon-3 icon-animation"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <h4 className="text-sub-heading mb-3">Referral</h4>
                  <p className="text-para">
                    Turn Loyal Customers into Brand Advocates
                  </p>
                  <ul className="timeline">
                    <li>
                      <h4>Customizable Referral Programs </h4>
                      <p>
                        Set up unique incentives, rewards, and redemption
                        options to encourage referral
                      </p>
                    </li>
                    <li>
                      <h4>
                        Incentivize Referrals – Incentivize both referrer and
                        referee{" "}
                      </h4>
                      <p>
                        Offer incentives to customers for referring their
                        friends and family; discounts free products
                      </p>
                    </li>
                    <li>
                      <h4>Track Referral Activity </h4>
                      <p>
                        Track and monitor performance of your referral
                        programs in real-time
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="framer-first" id="Dashboard" onWheel={() => handleScrollUp(3)}>
              <div className="row align-items-center justify-content-center gap-5 ">
                <div className="col-lg-6 text-center">
                  <div className="diy-image-container">
                    <img src={Images.wayTosuccessReporting} className="main-image" alt="" />
                    <img
                      src={Images.wayTosuccessReportingIcon1}
                      className="way-to-s-ReportingIcon-1 mt-3 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessReportingIcon2}
                      className="way-to-s-ReportingIcon-2 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessReportingIcon3}
                      className="way-to-s-ReportingIcon-3 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessReportingIcon4}
                      className="way-to-s-ReportingIcon-4 icon-animation"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <h4 className="text-sub-heading mb-3">Dashboard</h4>
                  <p className="text-para">
                    Insights Made Simple. Decisions Made Easier
                  </p>
                  <ul className="timeline small">
                    <li>
                      <h4>Real-Time Analytics</h4>
                      <p>
                        Actionable insights to understand customers & optimize
                        marketing strategies
                      </p>
                    </li>
                    <li>
                      <h4>Comprehensive Reporting</h4>
                      <p>
                        Actionable insights to understand customers & optimize
                        marketing strategies
                      </p>
                      <ol>
                        <li>Customer Analytics </li>
                        <li>Business Metrics </li>
                        <li>Product Metrics</li>
                        <li>Reward Analytics </li>
                      </ol>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="framer-second" id="Feedback" onWheel={() => handleScrollUp(4)}>
              <div className="row align-items-center justify-content-center gap-5 ">
                <div className="col-lg-6 text-center">
                  <div className="diy-image-container">
                    <img src={Images.wayTosuccessFeedback} className="main-image" alt="" />
                    <img
                      src={Images.wayTosuccessFeedbackIcon1}
                      className="way-to-s-feedbackIcon-1 mt-3 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessFeedbackIcon2}
                      className="way-to-s-feedbackIcon-2 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessFeedbackIcon3}
                      className="way-to-s-feedbackIcon-3 icon-animation"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <h4 className="text-sub-heading mb-3">Feedback </h4>
                  <p className="text-para">
                    Listen to What Your Customer REALLY Thinks (and Use it to
                    Win!)
                  </p>
                  <ul className="timeline">
                    <li>
                      <h4>Customizable Surveys </h4>
                      <p>
                        Craft custom surveys; including <b>NPS</b> questions to
                        improve overall customer satisfaction
                      </p>
                    </li>
                    <li>
                      <h4>Automated Feedback Requests </h4>
                      <p>
                        Set-up requests and reminders to ensure regular and
                        consistent customer feedback
                      </p>
                    </li>
                    <li>
                      <h4>Administer Post Sales Feedback</h4>
                      <p>
                        Capture feedback after key touchpoints in the customer
                        journey (e.g., post-purchase survey)
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="framer-1ad7c4t" id="DigitalReceipt" onWheel={() => handleScrollUp(5)}>
              <div className="row align-items-center justify-content-center gap-5 ">
                <div className="col-lg-6 text-center">
                  <div className="diy-image-container">
                    <img src={Images.wayTosuccessDr} className="main-image" alt="" />
                    <img
                      src={Images.wayTosuccessDrIcon1}
                      className="way-to-s-DrIcon-1 mt-3 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessDrIcon2}
                      className="way-to-s-DrIcon-2 icon-animation"
                      alt=""
                    />
                    <img
                      src={Images.wayTosuccessDrIcon3}
                      className="way-to-s-DrIcon-3 icon-animation"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-lg-5">
                  <h4 className="text-sub-heading mb-3">Digital Receipt</h4>
                  <p className="text-para">
                    Go Green & Offer Convenience with Digital Receipts
                  </p>
                  <ul className="timeline">
                    <li>
                      <h4>Customizable Templates </h4>
                      <p>
                        Design receipts with logo, and branding elements,
                        ensuring a consistent & professional look
                      </p>
                    </li>
                    <li>
                      <h4>Automated Delivery </h4>
                      <p>
                        Ensure that your customers receive their receipts
                        promptly and conveniently automatically across
                        channels
                      </p>
                    </li>
                    <li>
                      <h4>Personalized Offers </h4>
                      <p>
                        Include targeted promotions or offers within digital
                        receipts to encourage further purchases
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <Swiper
              direction={'vertical'}
              slidesPerView={1}
              spaceBetween={30}
              mousewheel={true}
              pagination={{ clickable: true }}
              onSlideChange={handleSlideChange} // Update tab when slide changes
              onSwiper={(swiper) => setSwiperInstance(swiper)} // Store Swiper instance
              modules={[Mousewheel, Pagination]}
              className="mySwiper"
            >
              <SwiperSlide>

              </SwiperSlide>

              <SwiperSlide>

              </SwiperSlide>

              <SwiperSlide>

              </SwiperSlide>

              <SwiperSlide>

              </SwiperSlide>

              <SwiperSlide>

              </SwiperSlide>

              <SwiperSlide>

              </SwiperSlide>
            </Swiper> */}



          <div className="row mt-5">
            <div className="col-lg-9 m-auto">
              <div className="d-flex justify-content-center text-center flex-column">
                <p className="text-para mb-4 text-para-custom">
                  Start Building Your Dream Loyalty Program Today!
                </p>
                <div>
                  <button
                    className="btn btn-schedule-demo"
                    onClick={() => handleShow()}>
                    Schedule a Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content popin-advantage-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 m-auto text-center">
              <h4 className="text-heading mb-4">Popin Advantage</h4>
              <h3 className="text-para mb-3">
              Unlocking Success, One Click at a Time
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-11 m-auto">
              <div className="popin-advantage-container">
                <div className="popin-advantage-box">
                  <img src={Images.advantageIcon1} alt="" />
                  <h4>Simplified user experience</h4>
                  <h3>70%</h3>
                  <p>
                    Brands favour Popin’s user-friendly interface to grow their
                    business
                  </p>
                </div>
                <div className="popin-advantage-box">
                  <img src={Images.advantageIcon2} alt="" />
                  <h4>Expert-recommended campaigns</h4>
                  <h3>80%</h3>
                  <p>
                    Increase in Engagement with Strategically Curated Campaigns
                  </p>
                </div>
                <div className="popin-advantage-box">
                  <img src={Images.advantageIcon3} alt="" />
                  <h4 className="wrap-nowrap">Expert support at every step</h4>
                  <h3>95%</h3>
                  <p>Satisfaction Rate with Popin's Dedicated Expert Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="advantage-section-footer"> */}
        {/* <div className="slider">
            <ul className="list-inline">
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
            </ul>
          </div> */}

        {/* <marquee behavior="scroll" direction="right" scrollamount="5">
            <ul className="list-inline mb-0">
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
              <li className="d-flex gap-2">
                Simply Dummy Text <img src={Images.rightAerrow} alt="" />
              </li>
            </ul>
          </marquee> */}
        {/* </div> */}
      </section>

      <section className="page-content why-choose-section">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-5">
              <h3 className="text-normal-heading mb-3">
                Why Brands Choose Popin
              </h3>
              <h4 className="text-heading mb-4">
                Easy DIY Integration with any Billing POS in under 5 Mins
              </h4>
              <p className="link-text-para hidden-xs">
                <button
                  className="btn btn-schedule-demo"
                  onClick={() => handleShow()}>
                  Partner with Us
                </button>
              </p>
            </div>
            <div className="col-lg-7 text-center">

              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                // pagination={{
                //   clickable: true,
                // }}
                // navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper"
              >
                <SwiperSlide>
                  <div className="logoblock">
                    <ul>
                      <li><img src={Images.logo1} className="main-image" alt="" /></li>
                      <li><img src={Images.logo2} className="main-image" alt="" /></li>
                      <li><img src={Images.logo3} className="main-image" alt="" /></li>
                    </ul>
                    <ul>
                      <li><img src={Images.logo4} className="main-image" alt="" /></li>
                      <li><img src={Images.logo5} className="main-image" alt="" /></li>
                      <li><img src={Images.logo6} className="main-image" alt="" /></li>
                    </ul>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logoblock">
                    <ul>
                      <li><img src={Images.logo7} className="main-image" alt="" /></li>
                      <li><img src={Images.logo8} className="main-image" alt="" /></li>
                      <li><img src={Images.logo9} className="main-image" alt="" /></li>
                    </ul>
                    <ul>
                      <li><img src={Images.logo10} className="main-image" alt="" /></li>
                      <li><img src={Images.logo11} className="main-image" alt="" /></li>
                      <li><img src={Images.logo12} className="main-image" alt="" /></li>
                    </ul>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logoblock">
                    <ul>
                      <li><img src={Images.logo13} className="main-image" alt="" /></li>
                      <li><img src={Images.logo14} className="main-image" alt="" /></li>
                      <li><img src={Images.logo15} className="main-image" alt="" /></li>
                    </ul>
                    <ul>
                      <li><img src={Images.logo16} className="main-image" alt="" /></li>
                      <li><img src={Images.logo17} className="main-image" alt="" /></li>
                      <li><img src={Images.logo18} className="main-image" alt="" /></li>
                    </ul>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logoblock">
                    <ul>
                      <li><img src={Images.logo19} className="main-image" alt="" /></li>
                      <li><img src={Images.logo20} className="main-image" alt="" /></li>
                      <li><img src={Images.logo21} className="main-image" alt="" /></li>
                    </ul>
                    <ul>
                      <li><img src={Images.logo22} className="main-image" alt="" /></li>
                      <li><img src={Images.logo23} className="main-image" alt="" /></li>
                      <li><img src={Images.logo24} className="main-image" alt="" /></li>
                    </ul>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="logoblock">
                    <ul>
                      <li><img src={Images.logo25} className="main-image" alt="" /></li>
                      <li><img src={Images.logo26} className="main-image" alt="" /></li>
                      <li><img src={Images.logo27} className="main-image" alt="" /></li>
                      <li><img src={Images.logo31} className="main-image" alt="" /></li>
                    </ul>
                    <ul>
                      <li><img src={Images.logo28} className="main-image" alt="" /></li>
                      <li><img src={Images.logo29} className="main-image" alt="" /></li>
                      <li><img src={Images.logo30} className="main-image" alt="" /></li>
                     
                    </ul>
                  </div>
                </SwiperSlide>
              </Swiper>
              <p className="link-text-para mt-5 visible-xs">
                <button
                  className="btn btn-schedule-demo"
                  onClick={() => handleShow()}>
                  Schedule a Demo
                </button>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="page-content customer-say-about">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <h4 className="text-heading mb-4">
                Brands that want to grow (like yours) trust us to deliver
              </h4>
              <h4 className="text-normal-heading mb-4">
                We love what our customers have to say about us
              </h4>
            </div>
          </div>
          <div className="row align-items-center mt-5">
            <div className="col-lg-8 p-0">
              <div className="diy-image-container">
                <img src={Images.customerSayImage} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-4 p-0">
              <div className="quote-bg-image">
                <img src={Images.customerSayImag1} alt="" />
                <h3 className="text-normal-heading mb-3 mt-2">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                </h3>
                <div className="author-detail mt-4">
                  <div className="white-line"></div>
                  <h4 className="author-name mt-3">Dr. Satish Kumar</h4>
                  <p className="author-d">Co-Founder, XYZ Solutions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="page-content achievement-section">
        <img src={Images.map} className="achievement-cover" alt="" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <h4 className="text-heading">
                We’ve achieved a lot of things that you’re going to see
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="achievement-card-container">
                <div className="achievement-card sm-card r-n-margin">
                  <h4 className="card-heading">
                    <CountUp
                      end={150}
                      duration={3}
                      suffix="+"
                      enableScrollSpy
                    />
                  </h4>
                  <p className="text-para">New Customers</p>
                </div>
                <div className="achievement-card md-card r-n-margin">
                  <h4 className="card-heading">
                    <CountUp
                      end={convert(1000000)}
                      decimals={1}
                      duration={4}
                      suffix="M+"
                      enableScrollSpy
                    />
                  </h4>
                  <p className="text-para">Social Media</p>
                </div>
                <div className="achievement-card lg-card ">
                  <img src={Images.trophy} alt="" />
                  <h4 className="card-heading">
                    <CountUp
                      end={10000}
                      duration={3}
                      suffix="+"
                      enableScrollSpy
                    />
                  </h4>
                  <p className="text-para">Happy Customers</p>
                </div>
                <div className="achievement-card md-card l-n-margin">
                  <h4 className="card-heading">
                    <CountUp
                      end={295}
                      duration={3}
                      suffix="+"
                      enableScrollSpy
                    />
                  </h4>
                  <p className="text-para">Earn Point Daily</p>
                </div>
                <div className="achievement-card sm-card l-n-margin">
                  <h4 className="card-heading">
                    <CountUp
                      end={400}
                      duration={3}
                      suffix="+"
                      enableScrollSpy
                    />
                  </h4>
                  <p className="text-para">Daily Sales Groth</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-content industries-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 m-auto text-center">
              <h4 className="text-normal-heading mb-3 mt-0">Industries</h4>
              <p className="text-para">
                Popin Works for You, No Matter What You Do <br /> Diverse
                Industries, One Powerful Solution, Empowering Businesses to
                Create Lasting Relationships
              </p>
            </div>
            <div className="col-lg-10 m-auto">
              <ul className="list-inline industries-tab  mt-4">
                <li className={activeTab === 1 ? "active" : ""}>
                  <a
                    onClick={() => {
                      handleTabActive(1);
                    }}>
                    <span>
                      <img src={Images.shoppingCart} alt="" />
                    </span>
                    <span>Retail</span>
                  </a>
                </li>
                <li className={activeTab === 0 ? "active" : ""}>
                  <a
                    onClick={() => {
                      handleTabActive(0);
                    }}>
                    <span>
                      <img src={Images.customerService} alt="" />
                    </span>
                    <span>
                      Hospitality
                      {/* Service */}
                    </span>
                  </a>
                </li>
                <li className={activeTab === 2 ? "active" : ""}>
                  <a
                    onClick={() => {
                      handleTabActive(2);
                    }}>
                    <span>
                      <img src={Images.skinCare} alt="" />
                    </span>
                    <span>
                      Health Care
                      {/* Beauty & Wellness */}
                    </span>
                  </a>
                </li>
                {/* <li className={activeTab === 3 ? "active" : ""}>
                  <a
                    onClick={() => {
                      handleTabActive(3);
                    }}>
                    <span>
                      <img src={Images.foodIcon} alt="" />
                    </span>
                    <span>Food & Beverage</span>
                  </a>
                </li>
                <li className={activeTab === 4 ? "active" : ""}>
                  <a
                    onClick={() => {
                      handleTabActive(4);
                    }}>
                    <span>
                      <img src={Images.fashionIcon} alt="" />
                    </span>
                    <span>Fashion</span>
                  </a>
                </li> */}
                {/* <li className={activeTab === 5 ? "active" : ""}>
                  <a
                    onClick={() => {
                      handleTabActive(5);
                    }}>
                    <span>
                      <img src={Images.fashionIcon} alt="" />
                    </span>
                    <span>And More</span>
                  </a>
                </li> */}
              </ul>

              {activeTab === 0 && (
                <div className="stats-container mt-5">
                  <ul className="list-inline">
                    <li>
                      <span>55+</span>
                      <span>Stores</span>
                    </li>
                    <li>
                      <span>9+</span>
                      <span>Brands</span>
                    </li>
                    {/* <li>
                      <span>XXXX</span>
                      <span>Outlets</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>customers</span>
                    </li> */}
                    <li>
                      <span>5500+</span>
                      <span>Campaigns</span>
                    </li>
                  </ul>
                </div>
              )}
              {activeTab === 1 && (
                <div className="stats-container mt-5">
                  <ul className="list-inline">
                    <li>
                      <span>250+</span>
                      <span>Stores</span>
                    </li>
                    <li>
                      <span>30+</span>
                      <span>Brands</span>
                    </li>
                    {/* <li>
                      <span>XXXX</span>
                      <span>Outlets</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>customers</span>
                    </li> */}
                    <li>
                      <span>17000+</span>
                      <span>Campaigns</span>
                    </li>
                  </ul>
                </div>
              )}
              {activeTab === 2 && (
                <div className="stats-container mt-5">
                  <ul className="list-inline">
                    <li>
                      <span>15+</span>
                      <span>Stores</span>
                    </li>
                    <li>
                      <span>5+</span>
                      <span>Brands</span>
                    </li>
                    {/* <li>
                      <span>XXXX</span>
                      <span>Outlets</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>customers</span>
                    </li> */}
                    <li>
                      <span>2100+</span>
                      <span>Campaigns</span>
                    </li>
                  </ul>
                </div>
              )}
              {activeTab === 3 && (
                <div className="stats-container mt-5">
                  <ul className="list-inline">
                    <li>
                      <span>XXXX</span>
                      <span>Stores</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>Brands</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>Outlets</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>customers</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>Revenue</span>
                    </li>
                  </ul>
                </div>
              )}
              {activeTab === 4 && (
                <div className="stats-container mt-5">
                  <ul className="list-inline">
                    <li>
                      <span>XXXX</span>
                      <span>Stores</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>Brands</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>Outlets</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>customers</span>
                    </li>
                    <li>
                      <span>XXXX</span>
                      <span>Revenue</span>
                    </li>
                  </ul>
                </div>
              )}

              <div className="d-flex justify-content-center text-center flex-column mt-5 mb-4">
                <p className="text-para mb-4 text-para-custom">
                  See How Popin Can Boots Your Sales
                </p>
                <div>
                  <button
                    className="btn btn-schedule-demo"
                    onClick={() => handleShow()}>
                    Get in Touch
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="page-content  mb-3">
        <div className="container">
          <div className="row align-items-center justify-content-between column-reverse">
            <div className="col-lg-6 text-center">
              <div className="success-image-container">
                <img src={Images.popinSuccess} className="main-image" alt="" />
                <img
                  src={Images.successIcon1}
                  className="success-icon-1 icon-animation"
                  alt=""
                />
                <img
                  src={Images.successIcon2}
                  className="success-icon-2 icon-animation"
                  alt=""
                />
                <img
                  src={Images.successIcon3}
                  className="success-icon-3 icon-animation"
                  alt=""
                />
                <img
                  src={Images.successIcon4}
                  className="success-icon-4 icon-animation"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-5">
              <h3 className="text-normal-heading mb-3">
                Grow Faster, Smarter, Stronger
              </h3>
              <h4 className="text-heading mb-4">
                Ditch the struggle and embrace the sweetness of success with
                Popin
              </h4>
              <p className="text-para">
                Expand your reach, engage with your customers, and take your business to new heights. Start maximizing your customer connections and driving business growth with Popin today!
              </p>
            
              <p className="text-para">
                Grow your business on your terms with Popin's {" "}
                <b>easy-to-use DIY customer engagement platform. </b> Start Your Popin Journey Today and experience the power of affordable <b>loyalty solutions!</b>
              </p>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-lg-9 m-auto">
              <div className="d-flex justify-content-center text-center flex-column">
                <p className="text-para mb-4">
                  Ready to Pop-in-to Action? Let's Make Your Business Boom with
                  Popin Today!
                </p>
                <div>
                  <button
                    className="btn btn-schedule-demo"
                    onClick={() => handleShow()}>
                    Schedule a Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* <section className="page-content get-a-demo-section mt-0 mb-0">
        <img src={Images.demoBanner} className="banner-image" alt="" />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h3 className="text-normal-heading mb-3 mt-5">
                Grow Faster, Smarter, Stronger
              </h3>
              <h4 className="text-heading mb-4">
                Ditch The Struggle and embrace the sweetness of success with
                Popin
              </h4>
              <div className="d-flex justify-content-center gap-2">
                <button
                  className="btn btn-schedule-demo bg-white"
                  onClick={() => handleShow()}>
                  Get a Demo
                </button>
                <button className="btn btn-link">Learn More...</button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <BookDemo showModal={show} handleCloseModal={handleClose} />
    </Fragment>
  );
}
